import { Settings, Utils } from 'common';
import React from 'react';

const { PackingSlipsView } = Settings;
const { Session, Util } = Utils;

const PackingSlipsWrapper = () => {
	const { AllowedTargetOrigin } = Session.getSettings();

	const completionCallback = close => {
		if (Session.getSettings().IsInWinClient) {
			window.close();
		} else if (close) {
			try {
				Util.postMessage(
					{ type: 'PackingSlips', close: true },
					AllowedTargetOrigin
				);
			} catch (error) {
				console.log(error);
			}
		}
	};

	const renderSamplePreviewModalFromWrapper = sampleUrl => {
		Util.postMessage(
			{
				type: 'PackingSlips',
				show: true,
				sampleUrl,
			},
			AllowedTargetOrigin
		);
	};

	return (
		<div className="account-packing-slips-wrapper common-settings main-view">
			<div className="settings-content">
				<PackingSlipsView
					completionCallback={completionCallback}
					renderSamplePreviewModalFromWrapper={
						renderSamplePreviewModalFromWrapper
					}
				/>
			</div>
		</div>
	);
};

export default PackingSlipsWrapper;
